import React, { ComponentPropsWithRef, FC } from 'react';
import { PlcSingleTabProps } from './Tab.types';

export const SingleTab: FC<PlcSingleTabProps & ComponentPropsWithRef<'div'>> = ({ children }) => <>{children}</>;
